export const GREY_900 = "#202124";
export const GREY_850 = "#2E2F32";
export const GREY_800 = "#3C4043";
export const GREY_700 = "#5F6368";
export const GREY_600 = "#80868B";
export const GREY_500 = "#9AA0A6";
export const GREY_400 = "#BDC1C6";
export const GREY_300 = "#DADCE0";
export const GREY_200 = "#E8EAED";
export const GREY_100 = "#F1F3F4";
export const GREY_50 = "#F8F9FA";

export const KAGGLE_BLUE = "#20BEFF";
export const KAGGLE_GREEN = "#1CCD76";
export const KAGGLE_PURPLE = "#651FFF";
export const KAGGLE_ORANGE = "#FF5C19";
export const KAGGLE_YELLOW = "#E5CF4A";
export const KAGGLE_BLACK = "#202124";
export const KAGGLE_WHITE = "#FFFFFF";
export const KAGGLE_FOCUS = "#20BEFF";

export const ILLUSTRATION_BLUE = "#20BEFF";
export const ILLUSTRATION_GREEN = "#1FA641";
export const ILLUSTRATION_YELLOW = "#FAE041";
export const ILLUSTRATION_BLACK = "#202124";

export const ELEVATION_1 =
  "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)";
export const ELEVATION_2 =
  "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 2px 6px 2px rgba(60, 64, 67, 0.15)";
export const ELEVATION_3 =
  "0 1px 3px 0 rgba(60, 64, 67, 0.3), 0 4px 8px 3px rgba(60, 64, 67, 0.15)";
export const ELEVATION_4 =
  "0 2px 3px 0 rgba(60, 64, 67, 0.3), 0 6px 10px 4px rgba(60, 64, 67, 0.15)";
export const ELEVATION_5 =
  "0 4px 4px 0 rgba(60, 64, 67, 0.3), 0 8px 12px 6px rgba(60, 64, 67, 0.15)";
